import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const UtmConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/utm/builder',
      component: FuseLoadable({
        loader: () => import('./UtmBuilder.js')
      })
    },
    {
      path: '/utm/gestione',
      component: FuseLoadable({
        loader: () => import('./GestioneUtm')
      })
    }
  ]
}
